import React, { Component } from 'react';
import { FormGroup, ControlLabel, HelpBlock, FormControl, Button } from 'react-bootstrap';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import fetch from "isomorphic-fetch";
import Header from './Header.js';
import DatePicker from 'react-bootstrap-date-picker';
import GlobalGoals from './resources/GlobalGoals.js';
import ReactDOM from 'react-dom';
import { WithContext as ReactTags } from 'react-tag-input';
//import TagsInput from 'react-tagsinput';

import './CreateProject.css';

import fire from './fire';

function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

const gloablGoalSuggestions = GlobalGoals.map((goal) => goal['short']);

class CreateProject extends Component {
  constructor(props) {
    super(props);
    let d = new Date();
    d.setDate(d.getDate()+7);
    this.state = {
      name: '',
      description: '',
      address: '',
      solutionDueDate: d.toISOString(),
      globalGoals: [],
      status: 0,
    };

    this.handleDeleteGG = (i) => {
        let tags = this.state.globalGoals;
        tags.splice(i, 1);
        this.setState({globalGoals: tags});
    };

    this.handleAdditionGG = (tag) => {
        let tags = this.state.globalGoals;
        tags.push({
            id: tags.length + 1,
            text: tag
        });
        this.setState({globalGoals: tags});
    };

    this.handleDragGG = (tag, currPos, newPos) => {
        let tags = this.state.globalGoals;

        // mutate array
        tags.splice(currPos, 1);
        tags.splice(newPos, 0, tag);

        // re-render
        this.setState({ globalGoals: tags });
    };
    //this.handleGGChange = (ggs) => this.setState({globalGoals: ggs});

    this.handleChangeLocation = (address) => this.setState({ address });

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = (e) => {
    e.preventDefault()
    geocodeByAddress(this.state.address)
          .then(results => getLatLng(results[0]))
          .then(latLng => {
            console.log('Success', latLng);
            console.log(this.state);
            fire.database().ref('projects').push({
              name: this.state.name,
              description: this.state.description,
              location: this.state.address,
              latLng: latLng,
              find_solution_due_date: this.state.solutionDueDate,
              create_date: new Date().toISOString(),
              globalGoals: this.state.globalGoals,
              status: this.state.status
            }).then(() => {
              window.location.href = '/';
            });
          })
          .catch(error => console.error('Error', error))
  }

  render() {
    const locationInputProps = {
      value: this.state.address,
      onChange: this.handleChangeLocation,
      placeholder: 'Search Places...',
    }

    const ggs = this.state.globalGoals;

    const formInstance = (
      <form>
        <FieldGroup
          id="projectName"
          type="text"
          label="Name"
          placeholder="Enter name of the project"
          onChange={
            (event) => {
              this.setState({name: event.target.value})
            }
          }
        />
        <FormGroup controlId="projectDescription">
          <ControlLabel>Description</ControlLabel>
          <FormControl
            componentClass="textarea"
            placeholder="Describe the project / issue..."
            onChange={
              (event) => {
                this.setState({description: event.target.value})
              }
            }
          />
        </FormGroup>

        <FormGroup controlId="projectGlobalGoals">
          <ControlLabel>Global Goal</ControlLabel>
            <FormControl
              componentClass="select"
              onChange={
                (event) => {
                  this.setState({globalGoals: event.target.value})
                }
              } >
              <option value="select">Select</option>
              <option value="No Poverty">No Poverty</option>
              <option value="Zero Hunger">Zero Hunger</option>
              <option value="Good Health and Well-being">Good Health and Well-being</option>
              <option value="Quality Education">Quality Education</option>
              <option value="Gender Equality">Gender Equality</option>
              <option value="Clean Water and Sanitation">Clean Water and Sanitation</option>
              <option value="Affordable and Clean Energy">Affordable and Clean Energy</option>
              <option value="Decent Jobs and Economic Growth">Decent Jobs and Economic Growth</option>
              <option value="Industry, Innovation and Infrastructure">Industry, Innovation and Infrastructure</option>
              <option value="Reduced Inequalities">Reduced Inequalities</option>
              <option value="Sustainable Cities and Communities">Sustainable Cities and Communities</option>
              <option value="Responsible Consumption and Production">Responsible Consumption and Production</option>
              <option value="Climate Action">Climate Action</option>
              <option value="Life Below Water">Life Below Water</option>
              <option value="Life on Land">Life on Land</option>
              <option value="Peace and Justice - Strong Institutions">Peace and Justice - Strong Institutions</option>
              <option value="Partnerships for the Goals">Partnerships for the Goals</option>
            </FormControl>
        </FormGroup>


        <FormGroup controlId="projectLocation">
          <ControlLabel>Location</ControlLabel>
          <PlacesAutocomplete inputProps={locationInputProps}/>
        </FormGroup>

        <FormGroup controlId="projectSolutionDueDate">
          <ControlLabel>Desired deadline</ControlLabel>
          <DatePicker
            id="example-datepicker"
            value={this.state.solutionDueDate}
            onChange={
              (value, formattedValue) => {
                this.setState({solutionDueDate: value})
              }
            } />
        </FormGroup>

        <Button onClick={this.handleSubmit} type="submit">
          Submit
        </Button>
      </form>
    );

    return (
      <div className="create-project">
        <Header/>
        <div className="create-project--form">
          {formInstance}
        </div>
      </div>
    );
  }
}

export default CreateProject;



// WEBPACK FOOTER //
// ./src/CreateProject.js